import React, { useEffect, useRef } from 'react';
import { ApiAuth } from '../../api/auth';
import { StyledResetPassword } from './styled';
import Logo from '../../components/Logo';
import { makeStyles } from '../../utils/styles';
import { useApi } from '../../hooks/useApi';
import { paths } from '../../routes';
import useQuery from '../../hooks/useQuery';
import { useHistory } from 'react-router-dom';
import FormResetPassword from '../../forms/FormResetPassword';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((css) => ({
    logo: css`
        margin-bottom: 50px;
    `,
    paper: css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        overflow: hidden;
        max-width: 380px;
        padding: 40px 40px 30px 40px;
        width: 100%;
        min-height: 200px;
    `,
    btn: css`
        padding: 10px 45px;
    `,
    typography: css`
        line-height: 1.8em;
        margin-bottom: 30px;
    `,
}));

const ResetPassword = () => {
    const styles = useStyles();
    const history = useHistory();
    const query = useQuery();

    const codeRef = useRef(null);
    const { t } = useTranslation()
    //Setup request
    const [{ loading }, resetPassword] = useApi(ApiAuth.resetPassword, { manual: true });

    //Update code value from query parameters
    useEffect(() => {
        const code = query.get("code");
        if (code) {
            codeRef.current = code;
        }
    }, [query]);

    //Redirect when code is empty
    useEffect(() => {
        if (!codeRef.current) {
            history.push(paths.login);
        }
    }, [resetPassword, history]);

    const handleSubmit = async (data) => {
        const res = await resetPassword(codeRef.current, data)
        if (res?.data) {
            toast.success(t("Hasło zostało zmienione."));
            history.push(paths.login);
        }
    };

    return (
        <StyledResetPassword>
            <Logo
                variant="white"
                customStyle={styles.logo}
            />
            <FormResetPassword loading={loading} onSubmit={handleSubmit} />
        </StyledResetPassword>
    )
}

export default ResetPassword;
